import Vue from 'vue';
import { DesignSystem } from '@jabardigitalservice/jds-design-system';
import PortalVue from 'portal-vue';
import toast from '@/plugins/toast';
import permission from '@/plugins/permission';
import unleash from '@/plugins/unleash';
import VueMeta from 'vue-meta';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import { axiosInterceptors } from './repositories/Repository';
import { axiosInterceptors as axiosInterceptorsMicrosite } from './repositories/microsite/Repository';
import router from './router';
import store from './store';
import App from './App';
import 'swiper/css/swiper.css';
import './assets/styles/main.css';

Vue.use(DesignSystem);
Vue.use(PortalVue);
Vue.use(toast);
Vue.use(permission);
Vue.use(VueMeta);
Vue.use(VueAwesomeSwiper);
axiosInterceptors(store);
axiosInterceptorsMicrosite(store);
Vue.use(unleash);

Vue.config.productionTip = false;

if (process.env.VUE_APP_ENV === 'local') {
  const { worker } = require('./mocks/browser');
  worker.start();
}

store.dispatch('auth/getUser')
  .then(() => store.dispatch('auth/getPermissions'))
  .then(() => store.dispatch('auth/getStatusChangedPassword'))
  .then(() => {
    new Vue({
      router,
      store,
      render: (h) => h(App),
    }).$mount('#app');
  });
